import React, { useState } from 'react'
import GenericModal from '../../../components/GenericModal'
import CsvMappingUpload from '../../../components/CsvMappingUpload'
import Dropdown from '../../../components/Dropdown'
import CreateAndEditFacultyAndStaff from '../CreateAndEditFacultyAndStaff'
import { ButtonType } from '../../../components/GenericButton/styles'
import { notification } from '../../../components/Notifications'
import { getTerm } from '../../../store/slices/termsSlice/selectors'
import { TableModalAction, type ApplyFiltersAndDispatchParams } from '../../../components/CustomTable/types'

interface FacultyAndStaffTopbarActionsProps {
  params: ApplyFiltersAndDispatchParams
  allowedActions?: string[]
  setUploadTaskId: (id: string | null) => void
  isTaskRunning: boolean
  onTaskBlock: () => void
}

const FacultyAndStaffTopbarActions: React.FC<FacultyAndStaffTopbarActionsProps> = ({ params, allowedActions = [], setUploadTaskId, isTaskRunning, onTaskBlock }) => {
  const [isUploadModal, setIsUploadModal] = useState<boolean>(false)
  const [isUploadRolesModal, setIsUploadRolesModal] = useState<boolean>(false)
  const [isCreateModal, setIsCreateModal] = useState<boolean>(false)

  const closeUploadModal = (): void => {
    setIsUploadModal(false)
    setIsUploadRolesModal(false)
  }

  const closeUploadRolesModal = (): void => {
    setIsUploadRolesModal(false)
  }

  const uploadApi = (): void => {
    if (isTaskRunning) { onTaskBlock(); return }
    setIsUploadModal(true)
  }

  const handleUploadRolesModal = (): void => {
    if (isTaskRunning) { onTaskBlock(); return }
    setIsUploadRolesModal(true)
  }

  const addManually = (): void => {
    if (isTaskRunning) { onTaskBlock(); return }
    setIsCreateModal(true)
  }

  const term = getTerm()

  const actionsMenuItems = [
    { text: 'Upload Faculty (.csv)', action: uploadApi },
    { text: 'Upload Faculty Roles (.csv)', action: handleUploadRolesModal },
    { text: 'Add Manually', action: addManually }
  ]

  return (
    <>
      {allowedActions.includes(TableModalAction.CREATE) && <Dropdown menuItems={actionsMenuItems} extraButtonProps={{ buttonType: ButtonType.Primary }} label='Add Faculty' />}
      <GenericModal
        isOpen={isCreateModal}
        title={'Add Faculty'}
        onClose={() => { setIsCreateModal(false) }}
        maxWidth='sm'
        action={false}
      >
        <CreateAndEditFacultyAndStaff handleCloseModal={() => { setIsCreateModal(false) }} params={params} />
      </GenericModal>

      <CsvMappingUpload isOpen={isUploadModal} onClose={closeUploadModal} modalTitle="Faculty" csvHeaderEndpoint="/api/users/csv_headers" uploadCsvEndpoint="/api/users/?is_faculty=True" hasCreatePermission={allowedActions.includes(TableModalAction.CREATE)} returnTaskId={(id) => { if (id) setUploadTaskId(id) }} onSuccess={() => { notification('Faculty successfully uploaded', { variant: 'success' }) }} />

      <CsvMappingUpload isOpen={isUploadRolesModal} onClose={closeUploadRolesModal} modalTitle="Roles" csvHeaderEndpoint="/api/users/roles/csv_headers" uploadCsvEndpoint={'/api/users/roles/'} uploadCsvEndpointApiParams={{ termId: term?.data?.termId }} hasCreatePermission={allowedActions.includes(TableModalAction.CREATE)} returnTaskId={(id) => { if (id) setUploadTaskId(id) }} onSuccess={() => { notification('Roles successfully uploaded', { variant: 'success' }) }}
      />
    </>

  )
}

export default FacultyAndStaffTopbarActions
